import { leaveBreadcrumb, notify } from "~/lib/bugsnag"

export async function subscribe(swName) {
    let swRegistration = null
    if ("serviceWorker" in navigator && window.isSecureContext) {
        swRegistration = await registerServiceWorker(swName)
    }
    return swRegistration
}

export async function unsubscribe() {
    if ("serviceWorker" in navigator && window.isSecureContext) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        for (let registration of registrations) {
            registration.unregister()
        }
        leaveBreadcrumb("The SW was unregistered")
    }
}

async function registerServiceWorker(swName = "basic-sw.js") {
    const swUrl = `/${swName}`
    try {
        // Don't get it from the cdn, there is a cross-origin issue
        const registration = await navigator.serviceWorker.register(swUrl)
        leaveBreadcrumb(`SW ${swName} was registered`)
        return registration
    } catch (error) {
        leaveBreadcrumb(`SW registration failed for ${swUrl}`)
        notify(error)
    }
}
